import { Modal, Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useEffect } from 'react';

const GolfAreaSettingModal = ({
  open,
  handleClose,
  spotAreas,
  refreshSpotAreas,
  handleCreateModalOpen,
  handleEditModalOpen,
  handleDeleteModalOpen,
}) => {
  const { t } = useTranslation();
  const [localSpotAreas, setLocalSpotAreas] = useState(spotAreas || []);

  // spotAreas prop이 변경되면 로컬 상태 업데이트
  useEffect(() => {
    setLocalSpotAreas(spotAreas || []);
  }, [spotAreas]);

  // 삭제 성공 시 로컬 상태에서 즉시 제거하는 콜백
  const handleDeleteSuccessCallback = deletedArea => {
    setLocalSpotAreas(prevAreas => prevAreas.filter(area => area.golfAreaId !== deletedArea.golfAreaId));
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '584px',
    height: '522px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '16px',
    overflow: 'hidden',
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <Box sx={modalStyle}>
        <Box
          sx={{
            height: '56px',
            backgroundColor: '#262626',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            p: '0 32px',
          }}>
          <Typography
            id="modal-modal-title"
            sx={{
              display: 'flex',
              flexDirection: 'tow',
              justifyContent: 'space-between',
              color: '#fff',
              fontSize: '20px',
              fontWeight: '600',
            }}>
            <Box sx={{ fontSize: '18px' }}>{t('Zoning')}</Box>
          </Typography>
          <CloseIcon sx={{ color: '#fff', width: '32px', height: '32px', cursor: 'pointer' }} onClick={handleClose} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100% - 56px)',
          }}>
          <Box
            sx={{
              flex: 1,
              p: '32px 32px',
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              overflowY: 'auto',
            }}>
            {localSpotAreas && localSpotAreas.length > 0 ? (
              localSpotAreas.map(area => (
                <Box
                  key={area.golfAreaId}
                  sx={{
                    p: '16px',
                    border: '1px solid #D9D9D9',
                    borderRadius: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#000' }}>
                        {area.golfAreaInfo?.areaName || ''}
                      </Typography>
                      <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#595959' }}>
                        {area.golfAreaInfo?.areaMemo || ''}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                      <Typography
                        onClick={() => {
                          if (handleEditModalOpen) {
                            handleEditModalOpen(area);
                          }
                        }}
                        sx={{
                          width: '60px',
                          height: '30px',
                          borderRadius: '8px',
                          border: '1px solid #D9D9D9',
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#55C982',
                          textAlign: 'center',
                          lineHeight: '30px',
                          cursor: 'pointer',
                        }}>
                        {t('EDIT')}
                      </Typography>
                      <Typography
                        onClick={() => {
                          if (handleDeleteModalOpen) {
                            handleDeleteModalOpen(area, handleDeleteSuccessCallback);
                          }
                        }}
                        sx={{
                          width: '60px',
                          height: '30px',
                          borderRadius: '8px',
                          border: '1px solid #D9D9D9',
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#EE735A',
                          textAlign: 'center',
                          lineHeight: '30px',
                          cursor: 'pointer',
                        }}>
                        {t('DELETE')}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))
            ) : (
              <Typography
                sx={{ fontSize: '16px', fontWeight: '400', color: '#737373', textAlign: 'center', mt: '40px' }}>
                {t('구역이 없습니다.')}
              </Typography>
            )}
          </Box>
          <Box
            sx={{
              p: '32px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderTop: '1px solid #E1E1E1',
            }}>
            <Button
              sx={{
                backgroundColor: '#D9D9D9',
                width: '120px',
                height: '48px',
                borderRadius: '16px',
                fontSize: '20px',
                color: '#000',
                '&:hover': { backgroundColor: '#D9D9D9' },
              }}
              onClick={handleClose}>
              {t('CANCEL')}
            </Button>
            <Button
              sx={{
                backgroundColor: '#0F7F85',
                width: '240px',
                height: '48px',
                borderRadius: '16px',
                fontSize: '20px',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                '&:hover': { backgroundColor: '#0F7F85' },
              }}
              onClick={() => {
                handleClose();
                if (handleCreateModalOpen) {
                  handleCreateModalOpen();
                }
              }}>
              <img src="/images/icons/add.svg" alt="add-zone" />
              {t('Create Zone')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default GolfAreaSettingModal;
